/**
 * @generated SignedSource<<40528ebec0584eb606139b5a16dd6e9f>>
 * @relayHash ed587056b8126761659725d58a2a6c8d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6c68d7da96edd6d79f9e0278e859ae61f503255861ad8d6a556cdb9b6d76e9be

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentProfileCardQuery$variables = {
  agentAri: string;
  cloudId: string;
  fetchByIdentity: boolean;
  identityAccountId: string;
};
export type AgentProfileCardQuery$data = {
  readonly agentStudio_agentById?: {
    readonly agent: {
      readonly name: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
    } | null;
  } | null;
  readonly agentStudio_agentByIdentityAccountId?: {
    readonly agent: {
      readonly name: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
    } | null;
  } | null;
};
export type AgentProfileCardQuery = {
  response: AgentProfileCardQuery$data;
  variables: AgentProfileCardQuery$variables;
};
({
  "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider": isUpliftEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isUpliftEnabled_provider from '@atlassian/studio-browse-kit/ui/agent-card/components/isAgentAuthorUpliftEnabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchByIdentity"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "identityAccountId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentAri"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = [
  {
    "fragment": {
      "kind": "InlineFragment",
      "selections": [
        (v5/*: any*/),
        {
          "kind": "FragmentSpread",
          "name": "AgentCardRelay_StudioBrowseKit"
        }
      ],
      "type": "AgentStudioAssistant"
    },
    "kind": "AliasedInlineFragmentSpread",
    "name": "agent"
  }
],
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "identityAccountId"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "picture"
},
v11 = [
  (v8/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v5/*: any*/),
      (v9/*: any*/),
      {
        "kind": "ScalarField",
        "name": "description"
      },
      {
        "kind": "ScalarField",
        "name": "isVerified"
      },
      {
        "kind": "ScalarField",
        "name": "isFavourite"
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__id"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "icon"
      },
      {
        "kind": "ScalarField",
        "name": "externalConfigReference"
      },
      {
        "kind": "ScalarField",
        "name": "identityAccountId"
      },
      {
        "kind": "LinkedField",
        "name": "identityAccount",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isUser"
          },
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "appType"
              }
            ],
            "type": "AppUser"
          },
          (v9/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "creatorType"
      },
      {
        "kind": "ScalarField",
        "name": "forgeCreator"
      },
      {
        "concreteType": "TeamV2",
        "kind": "LinkedField",
        "name": "authoringTeam",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "displayName"
          },
          (v9/*: any*/)
        ]
      },
      {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "accountStatus"
          },
          {
            "condition": "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "ScalarField",
                "name": "accountId"
              }
            ]
          },
          (v9/*: any*/)
        ]
      }
    ],
    "type": "AgentStudioAssistant"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v9/*: any*/)
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AgentProfileCardQuery",
    "selections": [
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": (v6/*: any*/)
          }
        ]
      },
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v7/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentByIdentityAccountId",
            "plural": false,
            "selections": (v6/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "AgentProfileCardQuery",
    "selections": [
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": (v11/*: any*/)
          }
        ]
      },
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v7/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentByIdentityAccountId",
            "plural": false,
            "selections": (v11/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6c68d7da96edd6d79f9e0278e859ae61f503255861ad8d6a556cdb9b6d76e9be",
    "metadata": {},
    "name": "AgentProfileCardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider": isUpliftEnabled_provider
    }
  }
};
})();

(node as any).hash = "6bb49a428565993244c38618367b96d4";

export default node;
